export default __webpack_public_path__ + "static/approach_infra-a563c5db88175624b80abe41627f65a2.webp";